import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'app/core/http/url.service';
import { LocaleModel } from 'app/core/languages/locale-model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly urlService: UrlService) {
  }

  public getAvailableLocales(): Observable<LocaleModel[]> {
    function appendCountryIfNeeded(locales: LocaleModel[]): LocaleModel[] {
      return locales.map(locale => {
        const moreThenOneLanguage = locales.filter(l => l.Language === locale.Language).length > 1;

        if (!moreThenOneLanguage) {
          return locale;
        }

        return {
          ...locale,
          Language: `${locale.Language} (${locale.Country})`
        };
      });
    }

    const url = this.urlService.buildServerApiUrl('Locales');

    return this.httpClient.get<LocaleModel[]>(url).pipe(map(appendCountryIfNeeded));
  }

  public getAllAvailableLocales(): Observable<LocaleModel[]> {
    const url = this.urlService.buildServerApiUrl('Locales/All');
    return this.httpClient.get<LocaleModel[]>(url);
  }
}
